const model = [
  'Текущий уровень компетенций',
  'Требования будущей роли',
  'Разрыв',
  'План развития',
  'Практика',
  'Повторная оценка',
  'Готов / требует дальнейшего развития',
];

export default function HowEvaluateReadiness() {
  return (
    <section className="py-16 md:py-24 bg-gray-50">
      <div className="max-w-4xl mx-auto px-6">
        <h2 className="text-2xl md:text-4xl font-bold text-gray-900 text-center mb-4">
          Как оценивать готовность резервиста
        </h2>
        <p className="text-teal-700 font-semibold text-center text-base md:text-lg mb-12">
          Потенциал — не равно готовность
        </p>

        <div className="flex flex-col items-center mb-12">
          {model.map((step, i) => (
            <div key={step} className="flex flex-col items-center">
              <div className={`px-6 py-3 rounded-lg text-sm md:text-base font-semibold text-center ${i === model.length - 1 ? 'bg-teal-600 text-white' : 'bg-white border border-teal-200 text-teal-700'}`}>
                {step}
              </div>
              {i < model.length - 1 && (
                <i className="ri-arrow-down-line text-teal-600 text-xl my-2"></i>
              )}
            </div>
          ))}
        </div>

        <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 text-center max-w-3xl mx-auto">
          <p className="text-base md:text-lg font-semibold text-gray-900 leading-relaxed">
            Оценка показывает уровень готовности, но не гарантирует успешное назначение. Итоговое решение принимается с учётом реальной ситуации и задач компании.
          </p>
        </div>
      </div>
    </section>
  );
}